import { Component, OnInit } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { FuncionesService } from 'src/app/shared/funciones/funciones.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'dashboard-root',
  templateUrl: './dashboard.component.html',
  providers: [DashboardService]
})
export class DashboardComponent implements OnInit {

  miFormulario: FormGroup;
  recaptchaValido: boolean = false;
  codigo: string = '';
  recapcha: boolean = false;

  constructor(
    public funcionesService: FuncionesService,
    private fb: FormBuilder,
    private dashboardService: DashboardService
  ){
    this.miFormulario = this.fb.group({
      // Otros controles de formulario
      recaptcha: ['', Validators.required]
    });
  }

  ngOnInit(): void {

  }

  resolvedCaptcha(captchaResponse: string): void {
    if (captchaResponse) {
      this.recaptchaValido = true;
    }
  }

  onSubmit(): void {
    if (this.miFormulario.valid && this.recaptchaValido) {

      this.recapcha = true;

    } else {
      this.recapcha = false;
      console.log('Captcha no válido o formulario incompleto');
    }
  }

  enviavalores(): any{
    if (this.codigo === '') {
      this.funcionesService.showWarning('Ingrese el código');
      return false;
    }
    if (!this.recapcha) {
      this.funcionesService.showWarning('Marque la casilla y presione el boton enviar');
      return false;
    }

    this.funcionesService.showLoading();
    this.dashboardService.obtener(this.codigo).subscribe(response => {
      this.dashboardService.downloadFile(this.codigo).subscribe(blob => {

        this.funcionesService.hideLoading();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = response.pdfQr;  // Nombre del archivo descargado
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    });
  }
}
